import { BackCoverPagesProps } from '../../models/BackCoverPagesProps.interface';
import SummarySection from './components/SummarySection';
import BackCoverSection from './components/BackCoverSection';
import { ListViewMode } from '../ListViewModeSwitcher';

const BackCoverPages = ({
                          bookData,
                          editSummary = false,
                          mode,
                          setSummaryModal,
                          targetRefs
                        }: BackCoverPagesProps) => {
  return (
    <div className="h-full flex justify-center items-stretch">
      {bookData &&
        (mode === ListViewMode.PAGE ? (
          <SummarySection
            mode="Page"
            bookData={bookData}
            setSummaryModal={setSummaryModal}
            targetRefs={targetRefs}
          />
        ) : (
          <BackCoverSection
            bookData={bookData}
            setSummaryModal={setSummaryModal}
            targetRefs={targetRefs}
          />
        ))}
    </div>
  );
};
export default BackCoverPages;
